import React from 'react';

import { FaCrown } from 'react-icons/fa';
import { Link, useLocation } from 'react-router-dom';

function Sidebar({ patientguid }) {
  const location = useLocation();
  const currentPath = location.pathname;

  const permissions = patientguid
    ? [
        { title: 'Dashboard', path: '/dashboard' },
        { title: 'Manage Patients', path: '/patients' },
        { 
          title: 'RgenX', 
          path: 'http://15.207.182.66:3000/',
          isPremium: true,
          isExternal: true 
        },
      ]
    : [
        { title: 'Dashboard', path: '/dashboard' },
        { title: 'Manage Patients', path: '/patients' },
      ];

  const isActive = (path) => path === currentPath;

  const activeLink = 'w-full p-3 px-4 bg-blue-100 font-semibold text-blue-500';
  const normalLink = 'w-full p-3 px-4 hover:bg-blue-50';
  const premiumLink = 'w-full p-3 px-4 bg-gradient-to-r from-yellow-400 to-yellow-600 text-white font-semibold shadow-md hover:shadow-lg transition-all duration-200';

  return (
    <aside className="h-screen w-full border-r border-slate-200 bg-gradient-to-t from-slate-100 to-white p-8">
      <img
        src="/images/rdxlogo.png"
        alt="logo"
        className="mx-auto h-16 object-contain"
      />
      <nav className="mt-12 flex flex-col text-sm">
        {permissions.map((item, index) => {
          return (
            item.isExternal ? (
              <a
                key={index}
                href={item.path}
                target="_blank"
                rel="noopener noreferrer"
                className={`mb-3 rounded-md ${item.isPremium ? premiumLink : normalLink} flex items-center justify-between`}
              >
                <span>{item.title}</span>
                {item.isPremium && <FaCrown className="text-white" />}
              </a>
            ) : (
              <Link
                key={index}
                to={item.path}
                className={`mb-3 rounded-md ${isActive(item.path) ? activeLink : normalLink}`}
              >
                {item.title}
              </Link>
            )
          );
        })}
      </nav>
    </aside>
  );
}

export default Sidebar;
